<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">My Payments</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-md-12 col-centered">
                <div class="inner-pay">
                  <div class="row">
                    <!-- <div class="col-md-12">
                      <div class="empty-data">
                        <img src="/media/icons/empty.png" />
                        <h2>No Records Available</h2>
                      </div>
                    </div> -->
                    <div class="col-md-12">
                      <div
                        v-if="course_payments.length > 0"
                        class="pay-list-area"
                      >
                        <div id="accordion">
                          <div
                            v-bind:class="
                              checkOverdue(
                                item.total_outstanding.outstanding_all
                              )
                            "
                            v-for="(item, index) in course_payments"
                            :key="index"
                          >
                            <div class="card-header" :id="'heading' + index">
                              <h5 class="mb-0">
                                <button
                                  class="btn btn-link"
                                  data-toggle="collapse"
                                  :data-target="'#collapse' + index"
                                  aria-expanded="true"
                                  :aria-controls="'collapse' + index"
                                >
                                  <span>Course Name:</span>
                                  <div class="course">
                                    {{ item.course.name }}
                                  </div>
                                </button>
                                <div class="amount multi">
                                  <div
                                    v-if="item.paid_total > 0.0"
                                    class="inner-status"
                                  >
                                    <div class="title">Paid</div>
                                    {{ currency.symbol }}
                                    {{ numberWithCommas(item.paid_total)
                                    }}<sup>{{ currency.code }}</sup>
                                  </div>
                                  <!-- <div class="inner-status cancel">
                                    <div class="title">Canceled</div>
                                    Rs. 3500.00
                                  </div> -->
                                  <div
                                    v-if="item.pending_totals.future_payments"
                                    class="inner-status pending"
                                  >
                                    <div class="title">Future Payments</div>
                                    {{ currency.symbol }}
                                    {{
                                      numberWithCommas(
                                        item.pending_totals.future_payments
                                      )
                                    }}<sup>{{ currency.code }}</sup>
                                  </div>
                                </div>
                                <b
                                  v-if="
                                    item.total_outstanding.outstanding_all > 0.0
                                  "
                                  >Over Due: {{ currency.symbol }}
                                  {{
                                    numberWithCommas(
                                      item.total_outstanding.outstanding_all
                                    )
                                  }}<sup>{{ currency.code }}</sup></b
                                >
                              </h5>
                            </div>
                            <div
                              :id="'collapse' + index"
                              class="collapse"
                              :aria-labelledby="'headingOne' + index"
                              data-parent="#accordion"
                              v-if="item.course.fee > 0.0"
                            >
                              <div class="card-body">
                                <div class="table-area">
                                  <table
                                    id="no-more-tables"
                                    class="table table-hover"
                                  >
                                    <thead>
                                      <tr>
                                        <th scope="col">Ins. No</th>
                                        <th scope="col" class="text-center">
                                          Receipt number
                                        </th>
                                        <th scope="col" class="text-right">
                                          Pay Amount ({{ currency.code }})
                                        </th>
                                        <th scope="col" class="text-center">
                                          Payment Date
                                        </th>
                                        <th scope="col" class="text-center">
                                          Payment Method
                                        </th>
                                        <th scope="col" class="text-center">
                                          Status
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          payment, index
                                        ) in item.payments"
                                        :key="index"
                                      >
                                        <td data-title="Ins. No">
                                          {{
                                            payment.payment_shedule
                                              .installment_no
                                          }}
                                        </td>
                                        <td
                                          data-title="Receipt number"
                                          class="text-center"
                                        >
                                          {{ payment.ref_no }}
                                        </td>
                                        <td
                                          data-title="Pay Amount"
                                          class="text-right"
                                        >
                                          {{ numberWithCommas(payment.amount) }}
                                        </td>
                                        <td
                                          data-title="Payment Date"
                                          class="text-center"
                                        >
                                          {{ payment.date }}
                                        </td>
                                        <td
                                          data-title="Payment Method"
                                          class="text-center"
                                        >
                                          {{ payment.payment_type }}
                                        </td>
                                        <td
                                          data-title="Status"
                                          class="text-center"
                                        >
                                          <span
                                            v-if="payment.status === 'paid'"
                                            class="
                                              badge badge-pill badge-success
                                            "
                                            >{{ payment.status }}</span
                                          >
                                          <span
                                            v-if="payment.status === 'cancel'"
                                            class="
                                              badge badge-pill badge-warning
                                            "
                                            >{{ payment.status }}</span
                                          >
                                          <span
                                            v-if="
                                              payment.status === 'processing'
                                            "
                                            class="
                                              badge badge-pill badge-secondary
                                            "
                                            >{{ payment.status }}</span
                                          >
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                            <div
                              v-else
                              :id="'collapse' + index"
                              class="collapse"
                              :aria-labelledby="'headingOne' + index"
                              data-parent="#accordion"
                            >
                              <div class="card-body">
                                <div class="empty-data">
                                  <img src="/media/icons/empty.png" />
                                  <h2>No Records Available</h2>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="card pay-due">
                            <div class="card-header" id="headingTwo">
                              <h5 class="mb-0">
                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                  <span>Course Name:</span> <div class="course">JAVA Programming</div>
                                </button>
                                <div class="amount">
                                  <div class="title">Paid</div>
                                  Rs. 15000.00
                                </div>
                                <b>Due: Rs. 35600.00</b>
                              </h5>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                              <div class="card-body">

                                <div class="table-area">
                                  <table class="table table-hover">
                                    <thead>
                                    <tr>
                                      <th scope="col">Ins. No</th>
                                      <th scope="col">Receipt number</th>
                                      <th scope="col">Pay Amount</th>
                                      <th scope="col">Payment Date</th>
                                      <th scope="col">Payment Method</th>
                                      <th scope="col" class="text-center">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                      <th scope="row">1</th>
                                      <td>859859859859859</td>
                                      <td>15000.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-success">Success</span></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">1</th>
                                      <td>859859859859859</td>
                                      <td>3500.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-danger">Due</span></td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="card pay-cancel">
                            <div class="card-header" id="headingThree">
                              <h5 class="mb-0">
                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                  <span>Course Name:</span> <div class="course">.NET Application Development 2</div>
                                </button>
                                <div class="amount multi">
                                  <div class="inner-status">
                                    <div class="title">Paid</div>
                                    Rs. 3500.00
                                  </div>
                                  <div class="inner-status cancel">
                                    <div class="title">Canceled</div>
                                    Rs. 3500.00
                                  </div>
                                </div>
                                <b>Due: 0.00</b>
                              </h5>
                            </div>
                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                              <div class="card-body">

                                <div class="table-area">
                                  <table class="table table-hover">
                                    <thead>
                                    <tr>
                                      <th scope="col">Installment No</th>
                                      <th scope="col">Receipt number</th>
                                      <th scope="col">Pay Amount</th>
                                      <th scope="col">Payment Date</th>
                                      <th scope="col">Payment Method</th>
                                      <th scope="col">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                      <th scope="row">1</th>
                                      <td>668968968959759</td>
                                      <td>3500.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-success">Success</span></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">2</th>
                                      <td>668968968959759</td>
                                      <td>3500.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-warning">Canceled</span></td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="card pay-pending">
                            <div class="card-header" id="headingFour">
                              <h5 class="mb-0">
                                <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                  <span>Course Name:</span> <div class="course">Automobile Engineering</div>
                                </button>
                                <div class="amount multi">
                                  <div class="inner-status">
                                    <div class="title">Paid</div>
                                    Rs. 3500.00
                                  </div>
                                  <div class="inner-status pending">
                                    <div class="title">Pending</div>
                                    Rs. 3500.00
                                  </div>
                                </div>
                                <b>Due: 0.00</b>
                              </h5>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                              <div class="card-body">

                                <div class="table-area">
                                  <table class="table table-hover">
                                    <thead>
                                    <tr>
                                      <th scope="col">Ins. No</th>
                                      <th scope="col">Receipt number</th>
                                      <th scope="col">Pay Amount</th>
                                      <th scope="col">Payment Date</th>
                                      <th scope="col">Payment Method</th>
                                      <th scope="col">Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                      <th scope="row">1</th>
                                      <td>5986986986986</td>
                                      <td>3500.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-success">Success</span></td>
                                    </tr>
                                    <tr>
                                      <th scope="row">2</th>
                                      <td>585985958958958958</td>
                                      <td>3500.00</td>
                                      <td>01/09/2020</td>
                                      <td>Card</td>
                                      <td><span class="badge badge-pill badge-secondary">Pending</span></td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>

                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                      <div v-else>
                        <div class="empty-data">
                          <img src="/media/icons/empty.png" />
                          <h2>No Records Available</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
var Cookies = require("vue-cookies");
var Config = require("../router/Config");
export default {
  name: "mypayments",
  components: {},
  props: ["getCourse"],
  data() {
    return {
      course_payments: [],
      holder: 0,
      total: 0,
      currency: [],
    };
  },
  mounted() {
    this.user = Cookies.get("userDetail");
    this.getStudentPayment();
    this.currency = Cookies.get("currency");
  },
  methods: {
    getStudentPayment: function () {
      axios
        .get(
          Config.API_URL +
            "/api/fe/student/payment-hostory/" +
            Cookies.get("studentId") +
            "?token=" +
            Cookies.get("accessToken")
        )
        .then((response) => {
          this.course_payments = response.data.data;
          console.log(this.course_payments);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkOverdue: function (amount) {
      if (amount > 0.0) {
        return "card pay-due";
      } else {
        return "card pay-success";
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/views/payment/payment";

@media only screen and (max-width: 767px) {
  .card .btn-link .course {
    word-break: normal !important;
    white-space: break-spaces;
  }
}
</style>
